import React from "react";
import { useNavigate } from "react-router-dom";
import ndovuHr from "../../assets/img/ndovuPayShield.png";

function Header() {
  const navigate = useNavigate();
  const handleLogin = () => {
    navigate("/login");
  };
  return (
    <span
      className={`font-bold cursor-pointer text-[25px] text-lightBlack dash-title flex items-center`}
      onClick={handleLogin}
    >
      <img
        loading="lazy"
        decoding="async"
        src={ndovuHr}
        alt="logo"
        className={`h-[7vh] object-contain`}
      />
      Ndovu <span className="text-darkOrange ml-2">H</span>{" "}
      <span className="text-red1">R</span>
    </span>
  );
}

export default Header;
